import React from "react";
import { transformRichText } from "../../../helpers/richText";
import { CalculatorTypes } from "../../../components/panels/CalculatorPanels/calculatorTypes";
import {
  RemortgageCalculatorPanel,
} from "../../../components/panels/CalculatorPanels/RemortgageCalculatorPanel";
import {
  StampDutyCalculatorPanel,
} from "../../../components/panels/CalculatorPanels/StampDutyCalculatorPanel";
import {
  AffordabilityCalculatorPanel,
} from "../../../components/panels/CalculatorPanels/AffordabilityCalculatorPanel";
import { SmartBuyerCalculatorPanel } from "../../../components/panels/CalculatorPanels/SmartBuyerCalculatorPanel";
import { LoanToValueCalculatorPanel } from "../../../components/panels/CalculatorPanels/LoanToValueCalculatorPanel";
import { CalculatorPanelV2 } from "../../../components/panels/CalculatorPanelsV2";

export const getCalculatorPanel = (props: any) => {
  const transformedProps = {
    ...props,
    description: props.description
      ? transformRichText(props.description.raw)
      : null,
    disclaimer: props.disclaimer
      ? transformRichText(props.disclaimer.raw)
      : null,
    fastestLender: props.fastestLender
      ? transformRichText(props.fastestLender.raw)
      : null,
  };
  const {
    id,
    title,
    description,
    disclaimer,
    footerHeading,
    footerText,
    ctaText,
    ctaUrl,
    secondCtaText,
    secondCtaUrl,
    calculatorType,
    defaultTab,
    multipleTabs,
    mortgageRateOverride,
    showExampleSavings,
    fastestLender,
    mortgageRateBasedOnLtv,
    betterV2,
  } = transformedProps;
  let CalculatorPanel;
  let calculatorId;
  switch (calculatorType) {
    case CalculatorTypes.REMORTGAGE:
      CalculatorPanel = RemortgageCalculatorPanel;
      CalculatorPanel.displayName = "RemortgageCalculatorPanel";
      calculatorId = "remortgage-calculator";
      break;
    case CalculatorTypes.STAMP_DUTY:
      CalculatorPanel = StampDutyCalculatorPanel;
      CalculatorPanel.displayName = "StampDutyCalculatorPanel";
      calculatorId = "stamp-duty-calculator";
      break;
    case CalculatorTypes.SMART_BUYER:
      CalculatorPanel = SmartBuyerCalculatorPanel;
      CalculatorPanel.displayName = "SmartBuyerCalculatorPanel";
      calculatorId = "smart-buyer-calculator";
      break;
    case CalculatorTypes.LTV:
      CalculatorPanel = LoanToValueCalculatorPanel;
      CalculatorPanel.displayName = "LoanToValueCalculatorPanel";
      calculatorId = "loan-to-value-calculator";
      break;
    case CalculatorTypes.AFFORDABILITY:
    default:
      CalculatorPanel = AffordabilityCalculatorPanel;
      CalculatorPanel.displayName = "AffordabilityCalculatorPanel";
      calculatorId = "affordability-calculator";
      break;
  }
  return betterV2 && multipleTabs
    ? (
      <CalculatorPanelV2
        defaultTab={defaultTab}
        multipleTabs={multipleTabs}
        mortgageRateBasedOnLtv={mortgageRateBasedOnLtv}
      />
    )
    : (
      <CalculatorPanel
        key={id}
        title={title}
        description={description}
        disclaimer={disclaimer}
        footerHeading={footerHeading}
        footerText={footerText}
        ctaText={ctaText}
        ctaUrl={ctaUrl}
        secondCtaText={secondCtaText}
        secondCtaUrl={secondCtaUrl}
        defaultTab={defaultTab}
        mortgageRateOverride={mortgageRateOverride || ""}
        showExampleSavings={showExampleSavings}
        isAtTopOfPage={props.idx === 0}
        id={calculatorId}
        fastestLender={fastestLender}
        mortgageRateBasedOnLtv={mortgageRateBasedOnLtv}
        betterV2={betterV2}
      />
    );
};
